import React, { useEffect, useState, useContext } from 'react';
import { useSnackbar } from 'notistack';
import {
  Button,
  Grid,
  Table,
  TableCell,
  TableContainer,
  AccordionSummary,
  Accordion,
  TableHead,
  TableRow,
  Paper,
  Popover,
  Checkbox,
  Modal,
  Link
} from '@material-ui/core';
import { makeStyles, withStyles, createStyles } from '@material-ui/core/styles';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import ShareIcon from '@material-ui/icons/Share';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import HelpIcon from '@material-ui/icons/Help';
import { PersonAdd } from '@material-ui/icons';
import { TFile, TFolderFile } from '../../types/cloudStorage/CloudFileList';
import { AddModal } from './AddModal';
import { TSelectItem } from '../../types/common';
import { FileDetailField } from './FileDetailModal';
import { FolderShareField } from '../parts/cloudStorage/FolderShareField';
import { FileFolderEditField } from '../parts/cloudStorage/EditFolderName';
import { DeleteAlertModal } from '../parts/cloudStorage/DeleteAlertModal';
import { FolderAuthorityModal } from '../parts/cloudStorage/FolderAuthorityModal';
import { FileList } from './FileList';
import { checkResData } from '../../utils/common';
import { getShareFileGuestList } from '../../apicalls/cloud/shareFile';
import type { TCurrentGuest } from '../../types/CloudStorageModal';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';
import { EGmoSignatureModal } from './EGmoSignatureModal';
import { EDaijinSignatureModal } from './EDaijinSignatureModal';

import { AuthInfoContext } from '../../AuthContextProvider';
import { ROLE } from '../../const/Const';

import {
  getAuthorizedOutsidePartner,
  updateFolderAuthority
} from '../../apicalls/cloud/cloudFile';
import { useRecoilState } from 'recoil';
import { isEContractServiceEnabledState } from '../../GlobalState';

type Tprops = {
  folder: TFolderFile;
  vendorsList: TSelectItem[];
  getValues: any;
  getFolderFileList: any;
  fileTypes: TSelectItem[];
  addSelectedFiles: (file: TFile) => void;
  removeSelectedFiles: (file: TFile) => void;
  addAllSelectedFiles: (file: TFile[]) => void;
  removeAllSelectedFiles: (file: TFile[]) => void;
  selectedFiles: TFile[];
  onDeleteFolder: (folderId: number) => void;
};

// 書類一覧用フォルダリスト
export const FolderField: React.FC<Tprops> = (props: Tprops) => {
  const {
    vendorsList,
    folder,
    getValues,
    getFolderFileList,
    fileTypes,
    addSelectedFiles,
    removeSelectedFiles,
    addAllSelectedFiles,
    removeAllSelectedFiles,
    selectedFiles,
    onDeleteFolder
  } = props;

  // 親から渡ってくる
  const folderId: number = folder.id;
  const folderName: string = folder.name;
  const constructId: number = folder.construct_id;
  const constructName: string = folder.construct_name;
  const fileList: TFile[] = folder.files;
  const eContractService: number = folder.e_contract_service_id;

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);
  const [isEContractServiceEnabled, setIsEContractServiceEnabled] =
    useRecoilState<any>(isEContractServiceEnabledState);

  // モーダルオープン
  const [modalOpen, setModalOpen] = React.useState(false);
  // 削除アラートモーダル
  const [openAlertModal, setOpenAlertModal] = React.useState(false);
  // 閲覧権限編集モーダル
  const [openFileFolderAuthorityModal, setOpenFileFolderAuthorityModal] =
    React.useState(false);
  // 詳細データ取得用
  const [fileId, setFileId] = useState<number>();
  // 詳細モーダル開閉用
  const [openDetailModal, setOpenDetailModal] = useState<boolean>(false);

  const [openSignatureModal, setOpenSignatureModal] = useState<boolean>(false);
  const [openDaijinSignatureModal, setOpenDaijinSignatureModal] =
    useState<boolean>(false);
  // フォルダ編集モーダル開閉用
  const [openEditFolderModal, setOpenEditFolderModal] =
    useState<boolean>(false);
  // フォルダ共有モーダル開閉用
  const [openShareFolderModal, setOpenShareFolderModal] =
    useState<boolean>(false);

  const [eSignatureFileId, setESignatureFileId] = useState<number>();
  const [eSignatureFileName, setESignatureFileName] = useState<string>('');

  const [value, setValue] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = useState(null);

  // 現在共有済みの共有先リスト
  const [currentGuestList, setCurrentGuestList] = useState<TCurrentGuest[]>([]);
  // 共有先が存在するかのフラグ
  const [isGuest, setIsGuest] = useState<boolean>(false);

  // アコーディオン制御用
  const [openAccordion, setOpenAccordion] = React.useState<boolean>(false);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onCheck = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (fileList && fileList.length > 0) {
      if (checked) {
        addAllSelectedFiles(fileList);
      } else {
        removeAllSelectedFiles(fileList);
      }
    }
    setValue(checked);
  };

  const onOpenAccordion = () => {
    if (openAccordion) {
      setOpenAccordion(false);
    } else {
      setOpenAccordion(true);
    }
  };

  // 現在の共有先リストを取得
  const getGuestList = () => {
    getShareFileGuestList(folderId).then(resData => {
      checkResData(resData, enqueueSnackbar).then(resData => {
        setCurrentGuestList(resData.share_list);
        setIsGuest(resData.share_list.length > 0);
      });
    });
  };

  useEffect(() => getGuestList(), [folderId]);

  return (
    <>
      <AddModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        vendorsList={vendorsList}
        fileTypes={fileTypes}
        constructId={getValues('construct_id').value}
        fileFolderId={folderId}
        getFolderFileList={getFolderFileList}
      />
      <Accordion
        expanded={fileList && fileList.length === 0 ? true : openAccordion}
        onChange={onOpenAccordion}
      >
        <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {/* 左側のフォルダ情報 */}
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '20px'
                }}
              >
                <FolderOpenIcon style={{ marginRight: 8 }} />
                <span style={{ fontWeight: 'bold', marginRight: 4 }}>
                  {folderName}
                </span>
                {isGuest && <PeopleAltIcon />}
                {authInfo?.role !== ROLE['OUTSIDE_PARTNER'] && (
                  <>
                    <MoreVertIcon
                      style={{ cursor: 'pointer', marginLeft: 12 }}
                      aria-describedby={id}
                      onClick={event => {
                        event.stopPropagation();
                        handleClick(event);
                      }}
                    />
                    <Popover
                      id={id}
                      open={open}
                      onClick={event => event.stopPropagation()}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                      <div>
                        <div
                          className={classes.popoverButton}
                          onClick={() => setOpenEditFolderModal(true)}
                        >
                          <CreateIcon style={{ marginRight: 8 }} />
                          フォルダを編集
                        </div>
                        <div
                          className={classes.popoverButton}
                          onClick={() => setOpenAlertModal(true)}
                        >
                          <DeleteIcon style={{ marginRight: 8 }} />
                          フォルダを削除
                        </div>
                        <div
                          className={classes.popoverButton}
                          onClick={() => setOpenFileFolderAuthorityModal(true)}
                        >
                          <PersonAdd style={{ marginRight: 8 }} />
                          公開する社外パートナー
                        </div>
                        <div
                          className={classes.popoverButton}
                          onClick={() => setOpenShareFolderModal(true)}
                        >
                          <ShareIcon style={{ marginRight: 8 }} />
                          フォルダを外部共有
                          <CustomTooltip
                            title={tooltipContents.ShareFileLink}
                            placement='right'
                            interactive
                          >
                            <HelpIcon
                              color='action'
                              style={{ marginLeft: 8 }}
                            />
                          </CustomTooltip>
                        </div>
                      </div>
                    </Popover>
                  </>
                )}
              </div>
              <div style={{ marginLeft: 12, color: 'gray' }}>
                {constructName}
              </div>
            </div>

            {/* 右側のボタンと登録数 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: 10,
                  marginRight: 14,
                  borderRight: '1px solid #cfcfcf'
                }}
              >
                登録数（{folder.file_count}件）
                <ExpandMoreIcon onClick={onOpenAccordion} />
              </div>
              <Button
                style={{ backgroundColor: '#007dff' }}
                onClick={event => {
                  event.stopPropagation();
                  setModalOpen(true);
                }}
                variant='contained'
                color='secondary'
              >
                <NoteAddIcon />
                <span style={{ marginLeft: 4 }}>資料を追加</span>
              </Button>
            </div>
          </div>
        </AccordionSummary>

        {fileList && fileList.length === 0 ? (
          <div style={{ padding: 16, color: 'gray' }}>
            フォルダに書類がありません
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table className={classes.main} aria-label='customized table'>
              <TableHead>
                <TableRow>
                  <StyledTableCell className={classes.table} align='center'>
                    <Checkbox
                      checked={value}
                      onChange={onCheck}
                      color='default'
                    />
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    書類名
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    資料種別
                  </StyledTableCell>
                  {authInfo?.role !== ROLE['OUTSIDE_PARTNER'] &&
                    isEContractServiceEnabled && (
                      <StyledTableCell className={classes.table} align='center'>
                        電子契約
                      </StyledTableCell>
                    )}
                  <StyledTableCell className={classes.table} align='center'>
                    送付先
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    受取元
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    金額
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    ファイル
                    <br />
                    サイズ
                  </StyledTableCell>
                  <StyledTableCell className={classes.table} align='center'>
                    日付
                  </StyledTableCell>
                  <StyledTableCell
                    className={classes.table}
                    align='center'
                  ></StyledTableCell>
                  <StyledTableCell
                    className={classes.table}
                    align='center'
                  ></StyledTableCell>
                  {authInfo?.role !== ROLE['OUTSIDE_PARTNER'] && (
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  )}
                </TableRow>
              </TableHead>
              {fileList.map((file, index) => (
                <FileList
                  key={index}
                  file={file}
                  addSelectedFiles={addSelectedFiles}
                  removeSelectedFiles={removeSelectedFiles}
                  setOpenDetailModal={setOpenDetailModal}
                  setOpenESignatureModal={setOpenSignatureModal}
                  setFileId={setFileId}
                  selectedFiles={selectedFiles}
                  setESignatureFileId={setESignatureFileId}
                  setESignatureFileName={setESignatureFileName}
                  constructId={constructId}
                />
              ))}
            </Table>
          </TableContainer>
        )}
      </Accordion>

      {/* 書類詳細表示モーダル */}
      <Modal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <FileDetailField
          fileId={fileId}
          constructId={getValues('construct_id').value}
          getFolderFileList={getFolderFileList}
          setOpenDetailModal={setOpenDetailModal}
        />
      </Modal>

      {/* 電子契約モーダル */}
      {/* GMOサイン */}
      {eContractService === 1 ? (
        <Modal
          open={openSignatureModal}
          onClose={() => setOpenSignatureModal(false)}
          aria-labelledby='simple-modal-title'
          aria-describedby='simple-modal-description'
          className={classes.container}
        >
          <EGmoSignatureModal
            setOpenESignatureModal={setOpenSignatureModal}
            constructId={constructId}
            eSignatureFileId={eSignatureFileId}
            eSignatureFileName={eSignatureFileName}
          />
        </Modal>
      ) : // 契約大臣
      eContractService === 2 ? (
        <Modal
          open={openSignatureModal}
          onClose={() => setOpenSignatureModal(false)}
          aria-labelledby='simple-modal-title'
          aria-describedby='simple-modal-description'
          className={classes.container}
        >
          <EDaijinSignatureModal
            setOpenESignatureModal={setOpenSignatureModal}
            constructId={constructId}
            eSignatureFileId={eSignatureFileId}
            eSignatureFileName={eSignatureFileName}
            getFolderFileList={getFolderFileList}
          />
        </Modal>
      ) : null}

      {/* フォルダ共有モーダル */}
      <Modal
        open={openShareFolderModal}
        onClose={() => setOpenShareFolderModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <FolderShareField
          folderId={folderId}
          folderName={folderName}
          constructId={constructId}
          setOpenShareFolderModal={setOpenShareFolderModal}
          currentGuestList={currentGuestList}
          getGuestList={getGuestList}
        />
      </Modal>
      {/* フォルダ編集モーダル */}
      <Modal
        open={openEditFolderModal}
        onClose={() => setOpenEditFolderModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <FileFolderEditField
          folderId={folderId}
          folderName={folderName}
          openEditFolderModal={openEditFolderModal}
          setOpenEditFolderModal={setOpenEditFolderModal}
          getFolderFileList={getFolderFileList}
        />
      </Modal>
      {/* フォルダ削除確認モーダル */}
      <DeleteAlertModal
        title={'フォルダ'}
        message={folderName}
        fileCount={folder.file_count}
        func={() => onDeleteFolder(folderId)}
        openAlertModal={openAlertModal}
        setOpenAlertModal={setOpenAlertModal}
      />
      {/* 閲覧権限編集モーダル*/}
      <Modal open={openFileFolderAuthorityModal} className={classes.container}>
        <FolderAuthorityModal
          constructId={constructId}
          folderId={folderId}
          folderName={folderName}
          setOpenFileAuthorityModal={setOpenFileFolderAuthorityModal}
          getAuthorizedOutsidePartner={getAuthorizedOutsidePartner}
          updateFolderAuthority={updateFolderAuthority}
        />
      </Modal>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#0099CC !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold',
      fontSize: 16
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    modal: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    popoverButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      cursor: 'pointer',
      borderBottom: '1px solid rgb(245, 245, 245)',
      padding: '20px 30px'
    }
  })
);

// スタイル関係
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);
